export default __webpack_public_path__ + "static/project-slide-2-415-700-6de7f990c0ef997b624d050fd6b0189f.jpg";